import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import ButtonProps from '@shared/types/props/button';

const KeyEraseIconContainer = styled.div<ButtonProps>`
  position: relative;
  left: ${7 * Screen.widthRatio}px;
  top: ${5 * Screen.widthRatio}px;
`;

export default KeyEraseIconContainer;
